import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@cms/ui/components/card";
import { Button } from "@cms/ui/components/button";
import { Input } from "@cms/ui/components/input";

export interface Faq {
  question: string;
  answer: string;
}

/**
 * The FAQ (AEO) editor card — question/answer pairs rendered on the live page
 * as an accordion plus FAQPage schema. Shared by the page and blog post
 * editors; callers gate it on the Growth/Pro plans.
 */
export function FaqsCard({ faqs, onChange }: {
  faqs: Faq[];
  onChange: (faqs: Faq[]) => void;
}) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm">FAQs</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground">
          Shown as an accordion on this page and as FAQ schema for search
          engines and AI assistants.
        </p>
        {faqs.map((faq, index) => (
          <div key={index} className="space-y-1.5 rounded-md border p-3">
            <Input
              value={faq.question}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(faqs.map((f, i) => (i === index ? { ...f, question: e.target.value } : f)))
              }
              placeholder="Question"
            />
            <Input
              value={faq.answer}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(faqs.map((f, i) => (i === index ? { ...f, answer: e.target.value } : f)))
              }
              placeholder="Answer"
            />
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onChange(faqs.filter((_, i) => i !== index))}
            >
              Remove
            </Button>
          </div>
        ))}
        <Button
          variant="outline"
          size="sm"
          onClick={() => onChange([...faqs, { question: "", answer: "" }])}
        >
          Add FAQ
        </Button>
      </CardContent>
    </Card>
  );
}
